import { render } from "./EmploiCard.vue?vue&type=template&id=6712baee&scoped=true"
import script from "./EmploiCard.vue?vue&type=script&lang=js"
export * from "./EmploiCard.vue?vue&type=script&lang=js"

import "./EmploiCard.vue?vue&type=style&index=0&id=6712baee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6712baee"]])

export default __exports__